const SDK_URL = "https://checkout-web-components.checkout.com/index.js";

let loadingPromise = null;

// Loads the Checkout.com Web Components SDK on demand and resolves with the
// global CheckoutWebComponents factory. Cached, so repeated payment attempts
// reuse the same <script> tag.
export function loadCheckoutFlow() {
  if (window.CheckoutWebComponents) {
    return Promise.resolve(window.CheckoutWebComponents);
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = SDK_URL;
    script.async = true;
    script.onload = () => {
      if (window.CheckoutWebComponents) {
        resolve(window.CheckoutWebComponents);
      } else {
        loadingPromise = null;
        reject(new Error("Checkout Flow SDK loaded but CheckoutWebComponents is missing"));
      }
    };
    script.onerror = () => {
      loadingPromise = null;
      script.remove();
      reject(new Error("Failed to load Checkout Flow SDK"));
    };
    document.head.appendChild(script);
  });

  return loadingPromise;
}

export const isCheckoutFlowEnabled = () => /*process.env.VUE_APP_CHECKOUT_FLOW_ENABLED === "true"*/ true;
